import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConstruction,
  defaultDescription,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'

export const agentApartmentRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    price: validationRules.price,
  },
  costs: {
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
    heatingCosts: validationRules.heatingCosts,
    courtageNote: validationRules.courtageNote,
    courtage: validationRules.courtage,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  otherFacilities: {
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    usableArea: validationRules.usableArea,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  objectNumbers: defaultObjectNumbers,
  construction: defaultConstruction,
  tenantDocuments: { solvency: [], rental: [], income: [], selfReport: [], identification: [] },
  apiSearchData: defaultApiSearchData,
}
